import { AppWrap } from '../../wrapper';
import { MdWork as WorkIcon } from 'react-icons/md';
import './Activities.scss'
import V_Container from "./Container/V_Container"
import activities_data from '../../data/activities.json';
import { images } from '../../constants'
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Activities = () => {
  const [topActivities, setTopActivities] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Show top 3 activities on the home page
    setTopActivities(activities_data.slice(0, 3));
  }, []);

  return (
    <>
      <h2 style={{ color: "var(--primary-color)" }}>Activities</h2>
      <div className="app__events-container">
        {topActivities.map((each, index) => (
          <V_Container key={index} data={each} />
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <button
          onClick={() => navigate('/all-activities')}
          className="experience-btn" /* Reusing experience btn style for consistency */
        >
          View All Activities
        </button>
      </div>
    </>
  );
};
export default AppWrap(Activities, 'activities');